import chalk from "chalk";
import { type Object3D } from "three";
import type { GLTF } from "three/examples/jsm/Addons.js";
import Logger from "@/lib/logger.ts";
import { isLight } from "./types.ts";

export default function fixupModel(onReady: (gltf: GLTF) => void) {
    return (gltf: GLTF) => {
        Logger.groupCollapsed("Model");

        gltf.scene.traverse((child) => {
            logChild(child);
        });

        Logger.groupEnd();

        onReady(gltf);
    };
}

function logChild(child: Object3D) {
    if (isLight(child)) {
        Logger.info(`${chalk.bgYellow.black(" Light ")} {${chalk.cyan(child.type)}:${chalk.green(child.name)}}`);
    }
}
